import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { PagePartComponent } from "@/model/Enums";
import { IPagePartOptions } from "@/model/pagePartOptions/IPagePartOptions";
import { TextOptions } from "@/model/pagePartOptions/TextOptions";
import { NoteOptions } from "@/model/pagePartOptions/NoteOptions";
import { MapOptions } from "@/model/pagePartOptions/MapOptions";
import { ResourceAndTextOptions } from "@/model/pagePartOptions/ResourceAndTextOptions";
import { RadioChoiceOptions } from "@/model/pagePartOptions/RadioChoiceOptions";
import { CheckboxChoicesOptions } from "@/model/pagePartOptions/CheckboxChoicesOptions";
import { FreeTextOptions } from "@/model/pagePartOptions/FreeTextOptions";
import { DownloadOptions } from "@/model/pagePartOptions/DownloadOptions";
import { PhotoCaptureOptions } from "@/model/pagePartOptions/PhotoCaptureOptions";
import { ConfirmToContinueOptions } from "@/model/pagePartOptions/ConfirmToContinueOptions";
import { PasscodeToContinueOptions } from "@/model/pagePartOptions/PasscodeToContinueOptions";

export interface IPagePart {
    id: string;
    pageID: string;
    displayOrder: number;
    component: PagePartComponent;
    options: any;
    copiedFromID: string;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;
}

export class PagePart implements IPagePart {

    constructor(data?: IPagePart) {
        if (data) this.update(data);
   }

    update(data: IPagePart): PagePart {
        mapData(data, {
            root: () => this,
            options: (data: IPagePartOptions) => PagePart.translateOptions(data)
        });
        return this;
    }

    id: string = Utils.emptyGuidValue;
    pageID: string = Utils.emptyGuidValue;
    displayOrder: number = 0;
    component: PagePartComponent = PagePartComponent.None;
    options: any = null;
    copiedFromID: string = Utils.emptyGuidValue;
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    get componentName() {
        const name = PagePartComponent[this.component] + "Part";
        if(name === "MapPart") {
            return this.options?.isGoogleMap === true ? "MapPartGoogle" : "MapPartLeaflet";
        }
        return name;
    }

    // need to add any future question types here
    get isQuestion() {
        return this.component === PagePartComponent.RadioChoice
            || this.component === PagePartComponent.CheckboxChoices
            || this.component === PagePartComponent.FreeText
            || this.component === PagePartComponent.PhotoCapture
            || this.component === PagePartComponent.ConfirmToContinue
            || this.component === PagePartComponent.PasscodeToContinue;
    }

    // need to add any future question types here
    get needsAnAnswer() {
        return this.component === PagePartComponent.RadioChoice
            || this.component === PagePartComponent.CheckboxChoices
            || this.component === PagePartComponent.PhotoCapture // ??? - todo - check this
            || this.component === PagePartComponent.ConfirmToContinue
            || this.component === PagePartComponent.PasscodeToContinue;
    }

    // this sucks a bit
    static translateOptions(data: IPagePartOptions): IPagePartOptions|null {
        //console.log("@@@ translateOptions - data = ", data);
        switch(data.component) {
            case PagePartComponent.Text: return new TextOptions(data);
            case PagePartComponent.Note: return new NoteOptions(data);
            case PagePartComponent.Map: return new MapOptions(data);
            case PagePartComponent.ResourceAndText: return new ResourceAndTextOptions(data);
            case PagePartComponent.RadioChoice: return new RadioChoiceOptions(data);
            case PagePartComponent.CheckboxChoices: return new CheckboxChoicesOptions(data);
            case PagePartComponent.FreeText: return new FreeTextOptions(data);
            case PagePartComponent.Download: return new DownloadOptions(data);
            case PagePartComponent.PhotoCapture: return new PhotoCaptureOptions(data);
            case PagePartComponent.ConfirmToContinue: return new ConfirmToContinueOptions(data);
            case PagePartComponent.PasscodeToContinue: return new PasscodeToContinueOptions(data);
        }
        console.warn("@@@ translateOptions - failed to create options: data = ", data);
        return null;
    }
}


